import React, { useEffect, createElement } from 'react';
import { CurrencyProvider } from './contexts/CurrencyContext';
import { NavBar } from './components/NavBar';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { BookOverview } from './components/BookOverview';
import { GapSection } from './components/GapSection';
import { DreamSection } from './components/DreamSection';
import { ComparisonTable } from './components/ComparisonTable';
import { ChapterTable } from './components/ChapterTable';
import { AudienceSection } from './components/AudienceSection';
import { PublisherStatement } from './components/PublisherStatement';
import { OfferStack } from './components/OfferStack';
import { GuaranteeSection } from './components/GuaranteeSection';
import { UrgencySection } from './components/UrgencySection';
import { CTASection } from './components/CTASection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
import { SocialProofToast } from './components/SocialProofToast';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
function initMetaPixel() {
  if (window.fbq) return;
  const n: any = window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const t = document.createElement('script');
  t.async = true;
  t.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(t);
  window.fbq('init', '5359469587611766');
  window.fbq('track', 'PageView');
}
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <CurrencyProvider data-id="element-0">
      <div className="min-h-screen bg-base text-text-primary selection:bg-accent-primary selection:text-base font-body" data-id="element-1">
        <NavBar data-id="element-2" />
        <main data-id="element-3">
          <HeroSection data-id="element-4" />
          <PainSection data-id="element-5" />
          <BookOverview data-id="element-6" />
          <GapSection data-id="element-7" />
          <DreamSection data-id="element-8" />
          <ComparisonTable data-id="element-9" />
          <ChapterTable data-id="element-10" />
          <AudienceSection data-id="element-11" />
          <PublisherStatement data-id="element-12" />
          <OfferStack data-id="element-13" />
          <GuaranteeSection data-id="element-14" />
          <UrgencySection data-id="element-15" />
          <CTASection data-id="element-16" />
          <FAQSection data-id="element-17" />
        </main>
        <Footer data-id="element-18" />
        <SocialProofToast data-id="element-19" />
      </div>
    </CurrencyProvider>;
}